import React, { useEffect, useState } from "react";
import { Modal, Input, Tooltip, Spin } from "antd";
import { CheckOutlined, SearchOutlined } from "@ant-design/icons";
import TableWithDynamicPagination from "../../table/table";
import { debounce, filter, map, sortBy } from "lodash";
import axios from "axios";
import sessionService from "@services/session.service";
import ExtraDetailsOfUser from "../detailsOfUser/detailsOfUser";
import { formatDisplayDate } from "@utils/helpers";
import "../matchingRecordsTable/matchingRecordsTable.scss";
import moment from "moment";

const { Search } = Input;

const SearchRecords = (props: {
  columnsNeedToShowInSearchPopUp: any;
  columnsNeedToShowInSearchTable: any;
  isLoading: boolean | undefined;
  handleMergeClick(arg0: { uniqueId: any; targetId: any }): void;
  payer: any;
  record: {
    member_unique_id: any;
    rec_group_id: any;
    member_first_name: any;
    member_last_name: any;
  };
  uniqueId: any;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [columnList, setColumnList] = useState<any>([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchedString, setSearchedString] = useState<any>(null);
  const columnsNeedToShowInTable = props.columnsNeedToShowInSearchTable;
  const columnsNeedToShowInPopUp = props.columnsNeedToShowInSearchPopUp;

  useEffect(() => {
    let _columns = map(columnsNeedToShowInTable, (item) => {
      if (item.key === "action_desc" || item.key === "action") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          render: (value: any, record: any) => {
            return (
              <div className="ui-empi-matching-records__table__action-column">
                <ExtraDetailsOfUser record={record} columnListForPopUp={columnsNeedToShowInPopUp} />
                <Tooltip title={"Merge Into this Patient"}>
                  <CheckOutlined onClick={() => props.handleMergeClick({ uniqueId: props?.record?.member_unique_id, targetId: record?.member_unique_id })} />
                </Tooltip>
              </div>
            );
          },
        };
      } else if (item.key === "member_dob") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          sorter: true,
          render: (value: any) => formatDisplayDate(value, "createDateFormat", "defaultDateFormat"),
        };
      } else {
        return { ellipsis: true, title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, sorter: true, render: (value: any) => value || "--" };
      }
    });

    _columns = sortBy(_columns, (item: any) => {
      return item.order;
    });

    setColumnList(_columns);
  }, [columnsNeedToShowInPopUp, columnsNeedToShowInTable, props]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchData = async (payload: any) => {
    console.log("ExpandableTable.fetchData.");
    setLoadingSearch(true);

    try {
      const _data = await axios
        .post(`${sessionService.getClient()?.appServiceUrl}/empi/search-records`, { ...payload, payerName: props.payer, groupId: props.record.rec_group_id, searchValue: searchedString })
        .then((response) => {
          return response.data.data.records;
        });
      setLoadingSearch(false);
      return { totalCount: _data?.count, data: _data?.empiRecords };
    } catch (e) {
      setLoadingSearch(false);
      return { totalCount: 0, data: [] };
    }
  };

  return (
    <>
      <Tooltip title={"Search More Patients"}>
        <SearchOutlined style={{ transform: "rotate(90deg)" }} onClick={() => setIsModalOpen(true)} autoFocus={true} size={300} />
      </Tooltip>
      <Modal className="ui-empi-search-pop-up" width={1000} centered title="Search EMPIs" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]}>
        <div className="ui-empi-matching-records">
          <div className="ui-empi-matching-records__name">{`${props.record.member_first_name} ${props.record.member_last_name}`}</div>
          <Spin spinning={loadingSearch} indicator={<></>}>
            <p className="ui-empi-matching-records__warning">
              Use this search bar to search EMPI, First Name, Last Name and DOB(MM-DD-YYYY) separated by <b>semi-colon</b> (<b>;</b>). Please refer the example in the placeholder.{" "}
            </p>
            <Search
              autoFocus={true}
              size="large"
              className="ui-empi-matching-records__search"
              placeholder="e.g. John ; Wick ; MM-DD-YYYY"
              loading={loadingSearch || props.isLoading}
              onChange={debounce((e) => {
                let x = filter(e?.target?.value.split(";"), (item) => {
                  return !!item.trim();
                })?.join(";");

                var dateType = /^(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])-\d{4}$/;
                x = map(x.split(";"), (item) => {
                  return dateType.test(item.trim()) ? moment(item).format("YYYY-MM-DD") : item;
                })?.join(";");

                setSearchedString(x);
              }, 1000)}
              prefix={<SearchOutlined />}
            />
          </Spin>
          <TableWithDynamicPagination
            key={`${searchedString?.length >= 3}`}
            dependencyPropsForPage1={searchedString}
            condition={searchedString?.length >= 3}
            className={"ui-empi-matching-records__table"}
            columns={columnList}
            handleFetchData={fetchData}
            columnOriginalList={columnsNeedToShowInTable}
            scrollProp={{ y: window.innerHeight - 590 }}
          />
        </div>
      </Modal>
    </>
  );
};

export default SearchRecords;
